import React from "react";

const BitcoinLogo = () => (
  <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-pink-500 text-8xl animate-fade z-[-1] opacity-5">
    <i className="fab fa-bitcoin"></i>
  </div>
);

export default BitcoinLogo;
